import { useEffect, useState } from "react";
import { Parallax } from "react-scroll-parallax";
import "./ParallaxAccueilStyle.css";
import SliderHome from "./SliderHome";
import i18next from "i18next";

const ParallaxAccueil = ({ t, sites, locations }) => {
  const [filteredData, setFilteredData] = useState(sites);
  const direction = i18next.language === "ar" ? "rtl" : "ltr";

  // Filter sites on every change of sites or locations
  useEffect(() => {
    // Example filter condition: filter sites that have a name (if needed)
    const filtered = sites.filter(({ name }) => name && name.toLowerCase());
    setFilteredData(filtered);
  }, [sites, locations]);

  return (
    <Parallax speed={-40} className="parallax-container">
      <div className="slider-accueil">
        <h2
          className="title-accueil"
          style={{
            direction: direction,
          }}
        >
          {t("xr_experiences")}{" "}
          <span className="span-accueil">{"10 " + t("vr_ar_visits")}</span>
        </h2>
        <br />
        <h3 className="subtitle-accueil" style={{ direction: direction }}>
          {t("archeological_sites")}
        </h3>
        <SliderHome data={filteredData} t={t} />
      </div>
    </Parallax>
  );
};

export default ParallaxAccueil;
